import { Col, Form, Row } from 'react-bootstrap';
import { InputBox } from '../form-elements/inputbox.component';
import { DropdownMenu } from '../form-elements/dropdownmenu.component';
import { maritalStatuses, primaryPhoneTypes, suffix } from './values';
import { InputBoxPhone } from '../form-elements/inputbox-phone.component';
import { InputBoxSsn } from '../form-elements/inputbox-ssn.component';
import { useEffect } from 'react';
import { BirthdayInputBox } from '../form-elements/birthday.component';

interface CoapplicantInformationFormProps {
  values?: any;
  errors?: any;
  touched?: any;
  handleChange?: any;
  handleBlur?: any;
  setFieldValue?: any;
}

export const initialValuesStepCoapplicantInformation = {
  // step #4
  haveCoApplicant: '',
  coapplicantFirstName: '',
  coapplicantMiddleName: '',
  coapplicantLastName: '',
  coapplicantSuffix: '',
  coapplicantPrimaryPhoneType: '',
  coapplicantPrimaryPhoneNumber: '',
  coapplicantEmailAddress: '',
  coapplicantMaritalStatus: '',
  coapplicantSsn: '',
  coapplicantBirthdate: '',
};

export const CoapplicantInformationForm: React.FC<CoapplicantInformationFormProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  useEffect(() => {
    if (values.haveCoApplicant === false) {
      setFieldValue('coapplicantFirstName', initialValuesStepCoapplicantInformation.coapplicantFirstName);
      setFieldValue('coapplicantMiddleName', initialValuesStepCoapplicantInformation.coapplicantMiddleName);
      setFieldValue('coapplicantLastName', initialValuesStepCoapplicantInformation.coapplicantLastName);
      setFieldValue('coapplicantSuffix', initialValuesStepCoapplicantInformation.coapplicantSuffix);
      setFieldValue('coapplicantPrimaryPhoneType', initialValuesStepCoapplicantInformation.coapplicantPrimaryPhoneType);
      setFieldValue(
        'coapplicantPrimaryPhoneNumber',
        initialValuesStepCoapplicantInformation.coapplicantPrimaryPhoneNumber
      );
      setFieldValue('coapplicantEmailAddress', initialValuesStepCoapplicantInformation.coapplicantEmailAddress);
      setFieldValue('coapplicantMaritalStatus', initialValuesStepCoapplicantInformation.coapplicantMaritalStatus);
      setFieldValue('coapplicantSsn', initialValuesStepCoapplicantInformation.coapplicantSsn);
      setFieldValue('coapplicantBirthdate', initialValuesStepCoapplicantInformation.coapplicantBirthdate);
    }
  }, [setFieldValue, values.haveCoApplicant]);

  return (
    <>
      <Row>
        <Col>
          <Form.Group>
            <Form.Label className="me-2">Do you have a Co-Buyer?</Form.Label>
            <Form.Check
              inline
              type="radio"
              name="haveCoApplicant"
              value="true"
              id="haveCoApplicant-yes"
              label="Yes"
              checked={values.haveCoApplicant === true}
              // onChange={handleChange}
              onChange={(event: any) => setFieldValue('haveCoApplicant', true)}
              onBlur={handleBlur}
              isValid={touched.haveCoApplicant && !errors.haveCoApplicant}
              isInvalid={touched.haveCoApplicant && errors.haveCoApplicant}
            />
            <Form.Check
              inline
              type="radio"
              name="haveCoApplicant"
              value="false"
              id="haveCoApplicant-no"
              label="No"
              checked={values.haveCoApplicant === false}
              // onChange={handleChange}
              onChange={(event: any) => setFieldValue('haveCoApplicant', false)}
              onBlur={handleBlur}
              isValid={touched.haveCoApplicant && !errors.haveCoApplicant}
              isInvalid={touched.haveCoApplicant && errors.haveCoApplicant}
            />
          </Form.Group>
        </Col>
      </Row>

      {values.haveCoApplicant === true ? (
        <div id="coapplicant-info">
          <Row>
            <Col xs={12}>
              <h3>Co-Buyer Information</h3>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6} lg={3}>
              <InputBox
                label="First Name"
                type="text"
                name="coapplicantFirstName"
                value={values.coapplicantFirstName}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantFirstName && !errors.coapplicantFirstName}
                isInvalid={touched.coapplicantFirstName && errors.coapplicantFirstName}
                errorFeedback={errors.coapplicantFirstName}
              />
            </Col>
            <Col xs={12} md={6} lg={3}>
              <InputBox
                label="Middle Name"
                name="coapplicantMiddleName"
                value={values.coapplicantMiddleName}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantMiddleName && !errors.coapplicantMiddleName}
                isInvalid={touched.coapplicantMiddleName && errors.coapplicantMiddleName}
                errorFeedback={errors.coapplicantMiddleName}
              />
            </Col>
            <Col xs={12} md={6} lg={3}>
              <InputBox
                label="Last Name"
                name="coapplicantLastName"
                value={values.coapplicantLastName}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantLastName && !errors.coapplicantLastName}
                isInvalid={touched.coapplicantLastName && errors.coapplicantLastName}
                errorFeedback={errors.coapplicantLastName}
              />
            </Col>
            <Col xs={12} md={6} lg={3}>
              <DropdownMenu
                label="Suffix"
                name="coapplicantSuffix"
                options={suffix}
                value={values.coapplicantSuffix}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantSuffix && !errors.coapplicantSuffix}
                isInvalid={touched.coapplicantSuffix && errors.coapplicantSuffix}
                errorFeedback={errors.coapplicantSuffix}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <InputBoxPhone
                label="Phone Number"
                name="coapplicantPrimaryPhoneNumber"
                value={values.coapplicantPrimaryPhoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.coapplicantPrimaryPhoneNumber && !errors.coapplicantPrimaryPhoneNumber}
                isInvalid={touched.coapplicantPrimaryPhoneNumber && errors.coapplicantPrimaryPhoneNumber}
                errorFeedback={errors.coapplicantPrimaryPhoneNumber}
              />
            </Col>
            <Col xs={12} md={6}>
              <DropdownMenu
                label="Phone Number Type"
                name="coapplicantPrimaryPhoneType"
                options={primaryPhoneTypes}
                value={values.coapplicantPrimaryPhoneType}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantPrimaryPhoneType && !errors.coapplicantPrimaryPhoneType}
                isInvalid={touched.coapplicantPrimaryPhoneType && errors.coapplicantPrimaryPhoneType}
                errorFeedback={errors.coapplicantPrimaryPhoneType}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <InputBox
                label="E-Mail Address"
                name="coapplicantEmailAddress"
                type="email"
                placeholder="john@example.com"
                value={values.coapplicantEmailAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantEmailAddress && !errors.coapplicantEmailAddress}
                isInvalid={touched.coapplicantEmailAddress && errors.coapplicantEmailAddress}
                errorFeedback={errors.coapplicantEmailAddress}
              />
            </Col>
            <Col xs={12} md={6}>
              <DropdownMenu
                label="Marital Status"
                name="coapplicantMaritalStatus"
                options={maritalStatuses}
                value={values.coapplicantMaritalStatus}
                onChange={handleChange}
                onBlur={handleBlur}
                isValid={touched.coapplicantMaritalStatus && !errors.coapplicantMaritalStatus}
                isInvalid={touched.coapplicantMaritalStatus && errors.coapplicantMaritalStatus}
                errorFeedback={errors.coapplicantMaritalStatus}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <InputBoxSsn
                label="SSN"
                name="coapplicantSsn"
                type="password"
                value={values.coapplicantSsn}
                onChange={handleChange}
                onBlur={handleBlur}
                setFieldValue={setFieldValue}
                isValid={touched.coapplicantSsn && !errors.coapplicantSsn}
                isInvalid={touched.coapplicantSsn && errors.coapplicantSsn}
                errorFeedback={errors.coapplicantSsn}
              />
            </Col>

            <Col xs={12} md={6}>
              <BirthdayInputBox
                label="Birth Date"
                name="birthdate"
                value={values.coapplicantBirthdate}
                onChange={(event: any) => setFieldValue('coapplicantBirthdate', event.target.value)}
                onBlur={handleBlur}
                isValid={touched.coapplicantBirthdate && !errors.coapplicantBirthdate}
                isInvalid={touched.coapplicantBirthdate && errors.coapplicantBirthdate}
                errorFeedback={errors.coapplicantBirthdate}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </>
  );
};
